import { Outlet } from 'react-router-dom';
import Navbar from '../feature/Navbar';
import Footer from '../feature/Footer';
import LiveChat from '../feature/LiveChat';

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-surface-50">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <LiveChat />
    </div>
  );
}